import { atom } from 'jotai'

import { AppDispatch } from './index.d'
import { ReduxStore } from './index'

export const reduxStoreAtom = atom<ReduxStore>({} as ReduxStore)

export const dispatchAtom = atom<AppDispatch>((get) => get(reduxStoreAtom).dispatch)
